module.exports = __webpack_public_path__ + "img/diners_club.279a80e2.svg";